export default __webpack_public_path__ + "static/media/newYearGiftSet.0fc1b69c.jpg";